import { Commit } from 'vuex'

import Review from '@/models/review'

import axios from '@/axios-module'

interface State {
  reviewIds: number[]
  reviewEntities: { [id: number]: Review }
  currentCustomerReviewId: number | null
  reviewLoaded: boolean
}

const initialState: State = {
  reviewIds: [],
  reviewEntities: {},
  currentCustomerReviewId: null,
  reviewLoaded: false,
}

export enum ReviewActionTypes {
  GetCustomerReview = '[Review] GetCustomerReview',
  Submit = '[Review] Submit',
}

export enum ReviewMutationTypes {
  LoadStarted = '[Messages] LoadStarted',
  GetCustomerReviewSuccess = '[Review] GetCustomerReviewSuccess',
  GetCustomerReviewFailure = '[Review] GetCustomerReviewFailure',
  SubmitSuccess = '[Review] SubmitSuccess',
  SubmitFailure = '[Review] SubmitFailure',
}

export default {
  state: initialState,
  getters: {
    getCurrentCustomerReview(state: State): Review | null {
      return state.currentCustomerReviewId
        ? state.reviewEntities[state.currentCustomerReviewId]
        : null
    },
  },
  actions: {
    async [ReviewActionTypes.GetCustomerReview](
      { commit }: { commit: Commit },
      bookingId: number,
    ) {
      commit(ReviewMutationTypes.LoadStarted)
      const response = await axios.get(`/customer/bookings/${bookingId}/review`)
      commit(ReviewMutationTypes.GetCustomerReviewSuccess, response.data)
    },
    async [ReviewActionTypes.Submit](
      { commit }: { commit: Commit },
      { review, bookingId }: { review: Review; bookingId: number },
    ) {
      const response = await axios.post(
        `/customer/bookings/${bookingId}/review`,
        { review },
      )
      commit(ReviewMutationTypes.SubmitSuccess, response.data)
    },
  },
  mutations: {
    [ReviewMutationTypes.LoadStarted](state: State) {
      state.reviewLoaded = false
    },
    [ReviewMutationTypes.GetCustomerReviewSuccess](
      state: State,
      review: Review,
    ) {
      setReview(state, review)
      state.currentCustomerReviewId = review.id
      state.reviewLoaded = true
    },
    [ReviewMutationTypes.SubmitSuccess](state: State, review: Review) {
      setReview(state, review)
      state.currentCustomerReviewId = review.id
      state.reviewLoaded = true
    },
  },
}

function setReview(state: State, review: Review) {
  state.reviewEntities = {
    ...state.reviewEntities,
    [review.id]: review,
  }

  if (state.reviewIds.indexOf(review.id) < 0) {
    state.reviewIds.push(review.id)
  }
}
